import React from "react";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import { isEmpty } from "lodash";
import { ReportModalContext } from "../../context";
import { getProfileAvatarByGender } from "../../../../../../../utils";

import "../../style.css";

const ReportedUserDetailsView = () => {
  const {
    report: { reportedBy = {}, createdAt },
  } = React.useContext(ReportModalContext);

  const values = React.useMemo(() => {
    let output = {
      postId: "",
      fullName: "",
      age: "",
      profession: "",
      civilStatus: "",
    };
    if (!isEmpty(reportedBy)) {
      output.postId = reportedBy?.id ?? "";
      output.fullName = reportedBy?.personalInfo?.displayName ?? "";
      output.age = reportedBy?.personalInfo?.age ?? "";
      output.profession = !isEmpty(reportedBy?.personalInfo?.professionOther)
        ? reportedBy?.personalInfo.professionOther
        : reportedBy?.personalInfo.profession?.name ?? "";
      output.civilStatus = reportedBy?.personalInfo?.civilStatus.status ?? "";
    }
    return output;
  }, [reportedBy]);

  return (
    <Grid
      container
      direction="column"
      className="reported-user-detailed-view p-16"
    >
      <Grid container justifyContent="space-between" className="gap-y-16">
        <Grid container xs alignItems="" className="gap-x-16">
          <img
            src={getProfileAvatarByGender(reportedBy?.personalInfo?.gender)}
            alt=""
            width={50}
            height={50}
            className="user-avatar"
          />
          <Grid container xs direction="column" className="">
            <Typography className="font-bold txt-primary">
              Reported By
            </Typography>
            <Typography style={{ marginTop: 4 }}>{values.fullName}</Typography>

            <Typography variant="caption" className="txt-secondary">
              {`${values.age} • ${values.profession} • ${values.civilStatus}`}
            </Typography>
            <Typography variant="caption" className="txt-secondary">
              {`# Post ID: ${values.postId}`}
            </Typography>
          </Grid>
        </Grid>

        <Grid container xs={3} direction="column" className="gap-y-4">
          <Typography variant="body2" className="txt-secondary">
            Reported At:
          </Typography>
          <Typography variant="body2">
            {moment.utc(createdAt).local().format("DD-MMM-YYYY hh:mm a")}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportedUserDetailsView;
